package kz.dentalcrm.app.screens.service_categories.list.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

sealed interface ServiceCategoriesViewEvent : ViewEvent {
    data class Search(val query: String) : ServiceCategoriesViewEvent
    data object Reload : ServiceCategoriesViewEvent
    data class EditCategory(val category: ServiceCategory) : ServiceCategoriesViewEvent
    data class DeleteCategory(val id: Int) : ServiceCategoriesViewEvent
}
